import { lazy } from 'react';

export default lazy(() =>
  import(/* webpackChunkName: 'process_list_page' */ './ProcessList'),
);
